// extracted by mini-css-extract-plugin
export default {"inputContainer":"WithdrawToCrypto_inputContainer__Zp+gt","smallText":"WithdrawToCrypto_smallText__bknUP","smallTextActive":"WithdrawToCrypto_smallTextActive__U4GCy"};